import { render } from "./AccountSetUp.vue?vue&type=template&id=6ddfced4"
import script from "./AccountSetUp.vue?vue&type=script&lang=js"
export * from "./AccountSetUp.vue?vue&type=script&lang=js"

import "./AccountSetUp.vue?vue&type=style&index=0&id=6ddfced4&scroped=true&lang=css"

import exportComponent from "/Users/tycooper/Desktop/Coding/Suites/barkbadge/barkbadge-wholesale/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__